<script>
  import LinksToSongs from "./LinksToSongs.svelte";
  import { onDestroy } from "svelte";
  import { lang } from "../lib/stores";
  let selectedLang;
  const unsubscribe = lang.subscribe((value) => selectedLang = value);
  onDestroy(unsubscribe);
  export let data = {};

  $: data;
</script>

<section class="mapWorld">
  <div class="p">
    <p><img src="/assets/img/world.webp" alt="Il mondo di Ghali" /></p>
    <p>
      {#if selectedLang === 'it'}
        Nei testi di Ghali troviamo <em class="data">{new Intl.NumberFormat('it-IT').format(data?.locationsStats?.totalTerms ?? 0)}</em>
        riferimenti a luoghi, sparsi in <em class="data">{new Intl.NumberFormat('it-IT').format(data?.locationsToSongs?.songs?.length ?? 0)}</em>
        brani. Si va da luoghi precisi (<em>Champs-Élisées</em> in <em>Cazzo Mene</em>, Lunga Vita a Sto, 2017) ad un luogo che per noi era
        impossibile rappresentare sulla mappa: l'<em>Universo</em> (<em>Habibi</em>, Album, 2017) passando per <em>Europa</em>, <em>Africa</em>
        riferimenti ai paesi della sponda sud del Mediterraneo o del Medio Oriente. <em>Quartiere</em> è il luogo più citato, <em>Milano</em>
        si piazza al secondo posto (ma ne parleremo tra poco), mentre la <em>Tunisia</em> è nominata solo una volta, in
        <em>Barcellona</em> (DNA, 2020).
      {:else}
        In Ghali's lyrics we find <em class="data">{new Intl.NumberFormat('en-US').format(data?.locationsStats?.totalTerms ?? 0)}</em> 
        references to places, spread across <em class="data">{new Intl.NumberFormat('en-US').format(data?.locationsToSongs?.songs?.length ?? 0)}</em> 
        songs. They range from specific places (<em>Champs-Élisées</em> in <em>Cazzo Mene</em> , Lunga Vita a Sto, 2017) to a place that
        was impossible for us to represent on the map: the <em>Universe</em> ( <em>Habibi</em> , Album, 2017) passing through <em>Europe</em>,
        <em>Africa</em>, references to the countries on the southern shore of the Mediterranean or the Middle East. <em>Quartiere</em> is
        the most cited place, <em>Milan</em> comes in second place (but we'll talk about it shortly), while <em>Tunisia</em> is mentioned only once, in
         <em>Barcelona</em> (DNA, 2020).
      {/if}
    </p>
  </div>
  <blockquote>
    <p>
      Che anche se tutto va al contrario Anna resta uguale e lo ama<br />
      E io continuo a bruciare <em>come paglia nel Sahara</em><br />
      Questo è per chi si è sentito solo con un padre che non chiama
    </p>
    <p><small>Come Milano, Lunga Vita a Sto, 2017</small></p>
  </blockquote>
  <div class="chart">
    <LinksToSongs data={data?.locationsToSongs ?? []} show="both" />
  </div>
  <blockquote>
    <p>
      Lo sai che ho ancora più paura dell'aereo<br />
      Se litighiamo prima di decollare<br />
      "<em>Eh sì, la Tunisia, la polizia</em>"<br />
      Quanto hai sofferto, mamma mia
    </p>
    <p><small>Barcellona, DNA, 2020</small></p>
  </blockquote>
</section>

<style>
  .mapWorld {
    display: block;
  }

  .mapWorld img {
    display: block;
    height: auto;
    width: 100%;
  }
</style>